import { useGetAdvancedParticipantQuery } from '../../advancedParticipant.generated'
import { readDetails } from './readDetails'

export const usePatientRecord = (uid: string) => {
  const { data, loading } = useGetAdvancedParticipantQuery({ variables: { uid } })
  const patient = data?.patient

  return {
    loading,
    patient,
    details: readDetails(patient?.details),
  }
}
